import React, { useState, useEffect, useRef } from 'react';
import GridRow from './gridRow.jsx';
import './gridStyle.css';

//Este componente se llama enviando un objeto que contiene dos objetos; uno title: que es un 
//array con con titulos, y otro data: que tiene a su ves un id: un print: que es lo que se
//imprime, y un rowData: donde se puede enviar info extra, que sirve para la funcion al hacer 
//click en alguna fila. Tambien recibe una funcion rowClick, que es una function con dos
//parametros (column, rowclick). El primero indica que columna recibio el click, se numeran
//empezando desde 0, y el segundo paramtro, devuelve lo enviado en rowClick.
//Para enviar un estilo a toda la linea, se agrega un objeto style al data, donde se te pasa un string con el estilo que tiene que ser de algun css, no un estilo en linea.

function GridColumn (props) {
  const [showActionsMenu, setShowActionsMenu] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  let style = `tr-grid-class ${props.data.style? props.data.style : ''}`

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowActionsMenu(false);
      }
    };

    if (showActionsMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showActionsMenu]);

  const handleMenuToggle = (e) => {
    e.stopPropagation();
    
    if (!showActionsMenu && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const menuHeight = (props.actions.options?.length || 0) * 40; // Aproximadamente 40px por item
      const viewportHeight = window.innerHeight;
      
      let top = rect.bottom + 2;
      const left = rect.right - 180; // 180px es el ancho mínimo del menú
      
      // Si no hay espacio abajo, abrir hacia arriba
      if (top + menuHeight > viewportHeight) {
        top = rect.top - menuHeight - 2;
      }
      
      setMenuPosition({ top, left });
    }
    
    setShowActionsMenu(!showActionsMenu);
  };

    return (
      <tr className = {style}>
      {
        props.data.print.map((item, index) => {
          return <GridRow
          data = {item}
          key = {index}
          rowClick = {props.rowClick}
          colNum = {index}
          rowData = {props.data.rowData}
          />
        })
      }
      {props.actions && props.actions.options && (
        <td className="td-grid-class td-actions">
          <div className="actions-menu-container" ref={menuRef}>
            <button 
              ref={buttonRef}
              className="actions-menu-button"
              onClick={handleMenuToggle}
            >
              ⋮
            </button>
            {showActionsMenu && (
              <div 
                className="actions-dropdown"
                style={{
                  top: `${menuPosition.top}px`,
                  left: `${menuPosition.left}px`
                }}
              >
                {props.actions.options.map((option, index) => (
                  <div 
                    key={index}
                    className="action-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      option.onClick(props.data.rowData);
                      setShowActionsMenu(false);
                    }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        </td>
      )}
      </tr>
    )
}

export default GridColumn
